const NAME = "auth";

// eslint-disable-next-line import/prefer-default-export
export { NAME };
